import { useApiQuery } from 'grabbitbot-legacy-ui'
import { paymentReads } from '../../api/fee'
import { PageTitle, QueryState } from '../../components/common'
import { TransactionTable } from '../../components/payment'
import { useProject } from '../../layout/projectContext'
import { useEmailParam } from '../../lib/useEmailParam'
import { sumSuccessfulByCurrency } from '../../lib/paymentHelpers'
import { AdminUserLocalMenu } from './AdminUserLocalMenu'

const SUMS: [string, string][] = [
  ['plan', 'Sum payment for subscriptions'],
  ['product', 'Sum payment for products'],
  ['credit', 'Sum payment for credits'],
  ['custom', 'Sum custom payment'],
]

/** Port of `AdminUserTransactionListComponent` (`…/admin/users/transactions?email=`):
 * an end-user's payment transactions plus the four per-type running totals
 * (successful only, per currency). */
export function AdminUserTransactionListPage() {
  const { projectId, project } = useProject()
  const email = useEmailParam()
  const q = useApiQuery(() => (email ? paymentReads.transactionsOfUser(projectId, email) : Promise.resolve([])), [projectId, email])
  const rows = q.data ?? []
  return (
    <div className="portal-card">
      <PageTitle title={`Transactions — ${project.name}`}>
        <AdminUserLocalMenu email={email} title="Transactions" />
      </PageTitle>
      {!email && <p className="portal-text-muted">Pick a user from the menu above.</p>}
      <QueryState loading={q.loading} error={q.error}>
        <div className="fs-stat-grid">
          {SUMS.map(([type, label]) => {
            const sums = sumSuccessfulByCurrency(rows, type)
            return (
              <div key={type} className="fs-panel" data-testid={`sum-${type}`}>
                <h3>{label}</h3>
                {sums.length === 0 ? (
                  <p className="fs-amount">-</p>
                ) : (
                  sums.map((s) => (
                    <p key={s.currency} className="fs-amount">
                      {s.total} {s.currency}
                    </p>
                  ))
                )}
              </div>
            )
          })}
        </div>
        <TransactionTable rows={rows} />
      </QueryState>
    </div>
  )
}
